import { NgxsModuleOptions, NoopNgxsExecutionStrategy } from '@ngxs/store';
import { RemoteClientState } from '../../page/remote-client-search/state/remote-client.state';
import { MetricState } from '../../page/system/state/metric.state';
import { AdminSystemState } from '../../page/system/state/system.state';
import { ApplicationConfig } from './application.config';
import { AuthState } from '../../shared/store/auth/auth.state';
import { ApplicationState } from '../../shared/store/application/application.state';
import { CacheDataState } from '../../shared/store/cache-data/cache-data.state';
import { NgxsStoragePluginOptions } from '@ngxs/storage-plugin';
import { UserState } from '../../page/user/store/user.state';
import { DistributorsState } from '../../page/library-management/store/distributors.state';
import { CategoriesState } from '../../page/library-management/store/categories.state';
import { DistributorState } from '../../page/library-management/store/distributor.state';
import { ProductsState } from '../../page/library-management/store/products.state';
import { SingleProductState } from '../../page/library-management/store/single-product.state';
import { RegionState } from '../../page/library-management/store/region.state';
import { IndicationsState } from '../../page/library-management/indications/state/indications.state';
import { BiomarkersState } from '../../page/library-management/biomarkers/state/biomarker.state';
import { SystemState } from '../../page/library-management/systems/state/system.state';
import { ServiceState } from '../../page/library-management/services/state/services.state';
import { MessageState } from '../../page/message/state/message.state';
import { AccountState } from '../../page/accounts/state/account.state';
import { SubscriptionState } from '../../page/accounts/state/subscription.state';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !ApplicationConfig.production,
  selectorOptions: {
    suppressErrors: false,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
  executionStrategy: NoopNgxsExecutionStrategy,
};

export const ngxsStorageConfig: NgxsStoragePluginOptions = {
  namespace: ApplicationConfig.applicationName,
  keys: ['auth.token', 'auth.account'],
};

export const ngxsStates = [
  AuthState,
  ApplicationState,
  CacheDataState,
  DistributorsState,
  CategoriesState,
  DistributorState,
  ProductsState,
  UserState,
  SingleProductState,
  RegionState,
  IndicationsState,
  BiomarkersState,
  SystemState,
  ServiceState,
  MessageState,
  AccountState,
  SubscriptionState,
  RemoteClientState,
  AdminSystemState,
  MetricState,
];
